module.exports = __webpack_public_path__ + "img/logo.c355613c.svg";